import { fetchCustomer, fetchCustomerByUuid } from "../../api/queries";

// The profile URL carries the customer's uuid — what the list links. Links
// from before that carried the numeric id, and a uuid can itself be all digits
// (8 hex chars), so a number is tried as a uuid first and only then as an id.
// That first try is silent: its 404 is expected, not an error to toast.
export async function loadCustomer(storeId, ref) {
  const mayBeLegacyId = /^\d+$/.test(ref);
  try {
    return await fetchCustomerByUuid(storeId, ref, { silent: mayBeLegacyId });
  } catch (error) {
    if (mayBeLegacyId && error.response?.status === 404) {
      return fetchCustomer(storeId, ref);
    }
    throw error;
  }
}

// One cache entry per customer reference, shared by the profile page and the
// list's side panel. Invalidate with the ["customer", storeId] prefix.
export const customerQueryKey = (storeId, ref) => ["customer", storeId, ref];

// What a list row is addressed by: its uuid, or the id for a row without one
// (none are expected; loadCustomer still resolves it).
export const customerRef = (customer) => String(customer?.uuid || customer?.id || "");
